import React, { createContext, useContext, useState } from "react";

const FilterContext = createContext();

export const FilterProvider = ({ children }) => {
  const [selectedCategories, setSelectedCategories] = useState([]);

  const updateFilters = (updatedCategories) => {
    setSelectedCategories(updatedCategories);
    localStorage.setItem("selectedFilters", JSON.stringify(updatedCategories));
  };

  const clearFilters = () => {
    setSelectedCategories([]);
    localStorage.removeItem("selectedFilters");
  };

  return (
    <FilterContext.Provider value={{ selectedCategories, updateFilters, clearFilters }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  return useContext(FilterContext);
};
